import axios from "axios";

import { buildFormRequestOptions } from "./formRequest";

export const baseUrl = process.env.REACT_APP_BASE_URL;

// export let baseUrl = "https://certage.0009.co/api/";

const redirectToMaintenanceIfNeeded = (response) => {
  if (
    response?.status === 503 &&
    response?.data?.maintenance === true &&
    window.location.pathname !== "/error"
  ) {
    //can't use navigate
    window.location.replace("/error?reason=maintenance");
  }
};

const statusToken = (() => {
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  const tokenFromUrl = fragment.get("status_token");

  if (tokenFromUrl) {
    sessionStorage.setItem("certage_status_token", tokenFromUrl);
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }

  return tokenFromUrl || sessionStorage.getItem("certage_status_token");
})();

const api = async (path, params, method) => {
  const requestMethod = (method || 'GET').toUpperCase();
  let csrfToken = null;

  if (!['GET', 'HEAD', 'OPTIONS'].includes(requestMethod)) {
    const csrfResponse = await axios(baseUrl + 'csrf-token', {
      headers: { Accept: 'application/json' },
      method: 'GET',
      withCredentials: true,
    });
    csrfToken = csrfResponse.data.csrf_token;
  }

  let options = {
    headers: {
      "Content-Type": "application/json",
      ...(statusToken && { Authorization: `Bearer ${statusToken}` }),
      ...(csrfToken && { 'X-CSRF-TOKEN': csrfToken }),
    },
    method: requestMethod,
    timeout: 30000,
    withCredentials: true,
    ...(params && { data: JSON.stringify(params) }),
  };

  return axios(baseUrl + path, options)
    .then((response) => {
      redirectToMaintenanceIfNeeded(response);

      return response;
    })
    .catch(async (error) => {
      const response = error.response;

      redirectToMaintenanceIfNeeded(response);

      return response;
    });
};

/**
 * Multipart helper for direct browser -> IDV document uploads.
 *
 * Kept separate from `api` on purpose:
 *  - `api` hard-codes application/json and JSON.stringify, which cannot carry files;
 *  - Content-Type is deliberately NOT set here, so the browser generates the
 *    multipart boundary itself (setting it manually produces a broken body);
 *  - withCredentials is false: this is a cross-origin call to a different
 *    service authenticated by a bearer token, and no Certage cookie may leak.
 *
 * Takes an absolute URL because the IDV origin comes from Certage's getConfig,
 * not from the Certage API base URL.
 */
export const apiForm = async (absoluteUrl, formData, token) => {
  return axios(absoluteUrl, buildFormRequestOptions(formData, token))
    .then((response) => response)
    .catch((error) => error.response);
};

export default api;
